import axios, { AxiosError } from 'axios';

import { isAuthEnabled } from '../auth/config';
import { clearTokens } from '../auth/token';

import { APIError } from './types';

const AUTH_ERROR_CODES = [401, 403];

export const apiErrorHandler = async (error: any) => {
  const apiError = toAPIError(error);

  if (
    isAuthEnabled &&
    axios.isAxiosError(error) &&
    error.response?.status &&
    AUTH_ERROR_CODES.includes(error.response.status)
  ) {
    clearTokens();
    window.location.href = '/login';
    return new Promise(() => {});
  }

  throw new Error(apiError.message || 'Unexpected server error');
};

const toAPIError = (error: any): APIError => {
  if (axios.isAxiosError(error)) {
    return handleAxiosError(error);
  } else {
    return {
      code: error.error || 'UnknownError',
      message: 'UnknownError',
      ...error,
    };
  }
};

const handleAxiosError = (error: AxiosError<any, any>): APIError => {
  const url = axios.getUri(error.request.config || error.response?.config);
  if (error.response?.data) {
    const message = error.response.data?.error || 'UnknownError';
    const code = error.response.status || 'UnknownError';
    return {
      code,
      message,
      url,
    };
  } else {
    return {
      code: error.code || 'UnknownError',
      message: error.message || 'UnknownError',
      url,
    };
  }
};
